import {GenreStaticLandingPageVo} from '../../common/shared/api/nicolas/vo/page/GenreStaticLandingPageVo.interface';
import {
  GroupType,
  LayoutType,
  Maybe,
  MetaInfoType,
  SectionType,
  StaticLandingGenreParamInput,
  StaticLandingGenreSection,
  StaticLandingType,
  User,
} from '../generated/types';
import {createDisplayAd} from './DisplayAd';
import {createPosterViewItem} from './PosterViewItem';
import {createPromotionBannerItem} from './PromotionBannerItem';
import {createSortOption} from './SortOption';
import {createStaticLandingGenreSectionParam} from './StaticLandingGenreSectionParam';

export function createStaticLandingGenreSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    genreStaticLandingPageVo: vo,
    input,
    type = LayoutType.Landing,
  }: {
    sectionId?: string;
    genreStaticLandingPageVo: GenreStaticLandingPageVo;
    input: StaticLandingGenreParamInput;
    type?: LayoutType;
  }
): StaticLandingGenreSection {
  const param = createStaticLandingGenreSectionParam(vo, input);

  return {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.Genre}-section-${type}-${
        param.categoryUid
      }-${param.subcategory?.param}-${param.sortType?.param}-${
        param.isComplete
      }${input.screenUid ? `-${input.screenUid}` : ''}`,
    type: SectionType.LandingGenre,
    groups: [
      {
        id: `static-landing-${StaticLandingType.Genre}-group-${
          param.categoryUid
        }-${param.subcategory?.param}${
          input.screenUid ? `-${input.screenUid}` : ''
        }-${param.sortType?.param}-${param.isComplete}`,
        type: GroupType.PosterView,
        items:
          vo.list?.map(item =>
            createPosterViewItem(userInfo, {
              itemSeriesDto: item,
              metaInfoType: MetaInfoType.ViewCount,
            })
          ) || [],
      },
    ],
    subcategoryList:
      vo.subcat_opt?.map(opt => createSortOption({sortOptVo: opt})) || [],
    sortTypeList:
      vo.sort_opt?.map(opt => createSortOption({sortOptVo: opt})) || [],
    isEnd: vo.is_end,
    totalCount: vo.total_count,
    title: vo.title,
    displayAd: vo.display_ad && createDisplayAd(vo.display_ad),
    promotionBanner: vo.section_promotion_banner
      ? createPromotionBannerItem(vo.section_promotion_banner)
      : undefined,
    param,
  };
}
